export const FLOOR_PLAN_RESERVATION_PILLS_TOUR_STORAGE_KEY =
  "floor-plan-reservation-pills-tour-completed"

export const FLOOR_PLAN_RESERVATION_PILLS_STEP = "reservation-pills"
